<template>
    <div class="field is-horizontal upcoming-days">
        <div class="field-body">
            <div class="display-flex">
                <div class="field all-days">
                    <day
                            v-for="(weekday, idx) in weekdays"
                            v-if="weekday"
                            :weekday="weekday"
                            :label="getDayLabel(idx)"
                            :date="getValueDateOfDay(idx)">

                    </day>
                </div>
                <div class="field"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import Day from './Day'

    export default {
        components: {
            Day
        },
        data() {
            return {
                weekdays: [
                    '',
                    'MONDAY',
                    'TUESDAY',
                    'WEDNESDAY',
                    'THURSDAY',
                    'FRIDAY',
                    'SATURDAY'
                ],
                selected: ''
            }
        },
        methods: {
            getDayLabel(day) {
                const d = new Date();
                if (d.getDay() === day) {
                    return moment().format('MM.DD')
                } else if (d.getDay() < day) {
                    const diffMore = d.getDay() - day
                    return moment().subtract(diffMore, 'day').format('MM.DD')
                } else {
                    const diffLess = d.getDay() + day + 1
                    return moment().add(diffLess, 'day').format('MM.DD')
                }
            },
            getValueDateOfDay(day) {
                const d = new Date();
                if (d.getDay() === day) {
                    return moment().format('Y-MM-DD')
                } else if (d.getDay() < day) {
                    const diffMore = d.getDay() - day
                    return moment().subtract(diffMore, 'day').format('Y-MM-DD')
                } else {
                    const diffLess = d.getDay() + day + 1
                    return moment().add(diffLess, 'day').format('Y-MM-DD')
                }
            },

        }
    }
</script>

<style scoped>
    .checkbox {
        padding-right: 15px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Auctions/Advance/Inputs/Days.vue